import { takeEvery } from 'redux-saga/effects';

import { normalize } from 'normalizr';

import * as actions from '../../actions/workplansVisits';
import * as historicalSchemas from '../../schemas/workplansHistoricalVisits';
import * as schemas from '../../schemas/workplansVisits';
import * as types from '../../types/workplansVisits';

import { store } from '@redux/storeConfig/store';
import camelcaseKeys from 'camelcase-keys';
import {
  getWorkplanAllVisitsListService,
  getWorkplanVisitsListService
} from '../../services/workplansVisits';

/* -------------------------------------------------------------------------- */
/*                              FETCH LIST VISITS                             */
/* -------------------------------------------------------------------------- */
function* fetchWorkplansVisits(action) {
  const filters = action.payload;

  getWorkplanVisitsListService(
    { ...filters },
    {
      successAction: (response) => {
        const resultData = response.data.map((result) => camelcaseKeys(result));
        const {
          entities: { workplansVisits },
          result //order
        } = normalize(resultData, schemas.workplansVisits); //normalize data to byId and order
        store.dispatch(actions.completeFetchingWorkplansVisits(workplansVisits, result));
      },
      errorAction: (error) => {
        store.dispatch(actions.failFetchingWorkplansVisits(error));
      }
    }
  );
}

export function* watchFetchWorkplansVisits() {
  yield takeEvery(types.WORKPLANS_VISITS_FETCH_STARTED, fetchWorkplansVisits);
}

/* -------------------------------------------------------------------------- */
/*                          FETCH LIST ALL VISITS                             */
/* -------------------------------------------------------------------------- */
function* fetchWorkplansAllVisits(action) {
  const { visitId } = action.payload;
  getWorkplanAllVisitsListService(
    { visitId },
    {
      successAction: (response) => {
        const resultData = response.data.map((result) => camelcaseKeys(result));
        const {
          entities: { workplansVisits },
          result //order
        } = normalize(resultData, historicalSchemas.workplansVisits); //normalize data to byId and order
        store.dispatch(actions.completeFetchingWorkplansAllVisits(workplansVisits, result));
      },
      errorAction: (error) => {
        store.dispatch(actions.failFetchingWorkplansAllVisits(error));
      }
    }
  );
}

export function* watchFetchWorkplansAllVisits() {
  yield takeEvery(types.WORKPLANS_ALL_VISITS_FETCH_STARTED, fetchWorkplansAllVisits);
}
